import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { FormGroup, FormControl, NgForm, ReactiveFormsModule } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { APILoginService } from '../../_services/login/API-login';
import { $ModalManagerService } from '../../../../_helpers/Modals/ModalManager.service';
import { $DBManagerService } from '../../../../_helpers/DB/DBManager.service';
import { Constants } from '../../../../_utils/Constants';
//import { APIEntityService } from '../../_services/entity/API-entity';
import { APIEntityService } from '../../_services/entity/API-entity';
import { MustMatch } from './password-match';

@Component({
	selector: 'app-forgot-password',
	templateUrl: './forgot-password.component.html',
	styleUrls: ['./forgot-password.component.css']
})
export class ForgotPasswordComponent implements OnInit {

	forgotPasswordForm: FormGroup;
	verifyOtpForm: FormGroup;
	updatePasswordForm: FormGroup;
	emailsmsopt: FormGroup;
	pwdcnfpwd: FormGroup;
	smsopt: FormGroup;
	public hide = true;
	public emailmobotp: boolean = false;
	//public passcpwd: boolean = false;
	public emailVerify: boolean = false
	public mobileVerify: boolean = false
	generate = true;
	verify = false;
	changePassword = false;
	currentMail = "";

	submitted1 = false;
	submitted2 = false;
	submitted3 = false;
	notApprovedMail = false;

	otpEExp: any;
	otpMExp: any;
	otpEmail: any;
	otpMobile: any;
	//entity_class: any;
	countSms: number = 0;
	countMail: number = 0;
	disableResendSms: boolean = false;
	disableResendMail: boolean = false;
	resendemailotpDisable:boolean=false; 
	resendesmsotpDisable:boolean=false;
	afterSubmit:boolean=true;

	constructor(private formBuilder: FormBuilder,
		private router: Router,
		private _route: ActivatedRoute,
		private $modal: $ModalManagerService,
		private ls: APILoginService,
		private es: APIEntityService,
		private db: $DBManagerService) {
		this._route.params.subscribe((params) => {
			//this.entity_class = params['role'];
		})
	}

	ngOnInit() {

		
		this.updatePasswordForm = this.formBuilder.group({
			entity_id: ['',],


		});

		this.emailsmsopt = this.formBuilder.group({
			email_otp: ['', [ Validators.pattern("[1-9][0-9]{3}"), Validators.minLength(4)]],

		})
		this.smsopt = this.formBuilder.group({
			mobile_otp: ['', [ Validators.pattern("[1-9][0-9]{3}"), Validators.minLength(4)]]
		})
		this.pwdcnfpwd = this.formBuilder.group({
			create_pwd: ['', Validators.required],
			confirm_pwd: ['', Validators.required]

		}, {
				validator: MustMatch('create_pwd', 'confirm_pwd')
			});

	}
	hideClick() {
		this.hide = !this.hide;
	}
	onSubmit() {

	}
	resendesmsotp() {
		this.resendesmsotpDisable = true
		this.countSms = this.countSms + 1;
		let data = {
			"email_otp": this.emailsmsopt.get("email_otp").value,
			"Entity_id": this.updatePasswordForm.controls.entity_id.value,
			"resendotpFor": "sms"
		}
		this.es.resendemailsmsOtp(data)
			.subscribe(r => {
			
				if (r.status == "success") {
					this.$modal.successModal({
						title: 'Entity Resend OTP',
						msg: 'Mobile OTP has been resend successfully!'
					});
					this.otpMExp = r.Mobile_OTP_Time + 900;
					this.otpMobile = atob(r.Mobile_OTP);

				}
				else {
					this.$modal.errorModal({
						title: 'Entity Resend OTP',
						msg: 'Error in sending OTP!'
					});
				}
			})
		if (this.countSms < 3) { 
			setTimeout(()=>{
				this.resendesmsotpDisable=false
			},90000) 
			
		} else {
			this.disableResendSms = true
		}
	}

	resendemailotp() {
		this.resendemailotpDisable = true
		this.countMail = this.countMail + 1;
		let data = {
			"Entity_id": this.updatePasswordForm.controls.entity_id.value,
			"resendotpFor": "mail"
		}

		this.es.resendemailsmsOtp(data)  
			.subscribe(r => {
			 
				if (r.message == "success") {
					//this.emailVerify = true;
					this.$modal.successModal({
						title: 'Entity Resend OTP',
						msg: 'Email OTP hasbeen sent successfully!'
					});
					this.otpEExp = r.Email_OTP_Time + 900;
					this.otpEmail = atob(r.Email_OTP);

				}
				else {
					this.$modal.errorModal({
						title: 'Entity Resend OTP',
						msg: 'Error in sending OTP!'
					});
				}
		})
		if(this.countMail < 3) { 
			setTimeout(()=>{
				this.resendemailotpDisable = false
			},90000)
			
		} else {
			this.disableResendMail = true;
		}
	}

	generateOTPForgotPwd() {
		if (this.updatePasswordForm.invalid) {
			return;
		}
		else {
			let data = { "id": this.updatePasswordForm.controls.entity_id.value }
			this.ls.generateOtpFP(data)
				.subscribe((res) => {

					if (res.status == "success") {
						this.emailmobotp = true;
						this.otpEmail = atob(res.Email_OTP);
						this.otpMobile = atob(res.Mobile_OTP);
						this.otpEExp = res.Email_OTP_Time + 900;
						this.otpMExp = res.Mobile_OTP_Time + 900;
						this.$modal.successModal({
							title: 'TM/PE Forgot Password',
							msg: 'OTP has been sent successfully to your registered Email Id & Mobile Number!'
						})
						this.afterSubmit=false;
					}
					else if (res.status == "fail") {
						if(res.err == "Not Exists"){
						 this.$modal.errorModal({
							title: 'TM/PE Forgot Password',
							msg: 'Entity ID Not Exists!'
						 })
						}
						else if(res.err == "Not PE/TM"){
						this.$modal.errorModal({
							title: 'TM/PE Forgot Password',
							msg: 'Please Enter a valid EntityID'
						})
						}
						else{
						this.$modal.errorModal({
							title: 'TM/PE Forgot Password',
							msg: 'Error sending the OTP!'
						})
						}
					}
				});
		}

	}
	onSubmitEmailOTP() {

		if (this.emailsmsopt.invalid) {
			return;
		}
		else {

			let currenttime = Math.floor(new Date().getTime()/1000)
			let eOTP = this.emailsmsopt.get("email_otp").value;
			if (eOTP == this.otpEmail) {
				if (currenttime > this.otpEExp) {
					this.$modal.errorModal({	
						title: 'TM/PE Forgot Password',
						msg: 'OTP has expired!'
					})

				} else {
					this.emailVerify = true;
					//this.passcpwd = true;
					this.resendemailotpDisable = true
					//this.clicked = true;
					this.$modal.successModal({
						title: 'TM/PE Forgot Password',
						msg: 'Email OTP verified!'
					})
					 					
					

				}
			} else {
				this.$modal.errorModal({
					title: 'TM/PE Forgot Password',
					msg: 'Entered wrong OTP!'
				})
			}


		}
	}

	onSubmitSmsOTP() {
		if (this.smsopt.invalid) {
			return;
		}
		else {


			let currenttime = Math.floor(new Date().getTime()/1000)
			let mOTP = this.smsopt.get("mobile_otp").value;
			if (mOTP == this.otpMobile) {
				if (currenttime > this.otpMExp) {
					this.$modal.errorModal({
						title: 'TM/PE Registration',
						msg: 'OTP has expired!'
					})

				} else {
					this.mobileVerify = true
					//this.passcpwd = true;
					this.resendesmsotpDisable=true
					this.$modal.successModal({
						title: 'TM/PE Registration',
						msg: 'Mobile OTP verified!'
					})
					
					

				}
			} else {
				this.$modal.errorModal({
					title: 'TM/PE Registration',
					msg: 'Entered wrong OTP!'
				})
			}

		}
		//this.passcpwd = true;
	}



	onSubmitPassword() {
		if (this.pwdcnfpwd.invalid) {
			return;
		}
		else {

			let data = {
				"id": this.updatePasswordForm.controls.entity_id.value,
				"create_pwd": this.pwdcnfpwd.get('create_pwd').value,
				"confirm_pwd": this.pwdcnfpwd.get('confirm_pwd').value,
			}

			this.es.ForgetPwdChange(data)
				.subscribe(r => {
				
					if (r.status == "success") {
						this.$modal.successModal({
							title: 'Entity Password Modification',
							msg: 'Password has been updated successfully!'
						});
					}
					else {
						this.$modal.errorModal({
							title: 'Entity Password Modification',
							msg: 'Error in Updating the Password'
						});
					}
					this.router.navigateByUrl('/');
				})
		}

	}

	get f3() { return this.updatePasswordForm.controls; }
	get f1() {
		return this.emailsmsopt.controls;
	}
	get f2() {
		return this.pwdcnfpwd.controls;
	}
	get f4() {
		return this.smsopt.controls;
	}


}
